import React, { useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch, useSelector } from 'react-redux'
import TextField from '../../elements/form/TextField'
import TextareaField from '../../elements/form/TextareaField'
import { Switch } from '@headlessui/react'
import { ERROR } from '../../../store/types'
import { createDesignation } from '../../../store/actions/designationActions'
import SelectField from '../../elements/form/SelectField'
import PlusIcon from '../../elements/icons/PlusIcon'
import TrashIcon from '../../elements/icons/TrashIcon'

const NewStaffDesignation = ({reload, closeFunction}) => {
    const dispatch = useDispatch()
    const designationsSelector = useSelector((state => state.designations))
    const departmentsSelector = useSelector((state => state.departments))

    const [designationPayload, setDesignationPayload] = useState({});
    const [validationErrors, setValidationErrors] = useState({});
    const [forDepartment, setForDepartment] = useState(false);
    const [responsibilities, setResponsibilities] = useState(['']);

    const addResponsibility = ()=>{
        let tempPayload = [...responsibilities]
        tempPayload.push('')
        setResponsibilities(tempPayload)
    }
    
    const updateResponsibility = (index, value)=>{
        let tempPayload = [...responsibilities]
        tempPayload[index] = value
        setResponsibilities(tempPayload)
    }
    
    const removeResponsibility = (index)=>{
        let tempPayload = [...responsibilities]
        tempPayload.splice(index, 1)
        setResponsibilities(tempPayload)
    }

    const validateForm = () => {
        let errors = {}
        if(!designationPayload.name || designationPayload.name === '') {
            errors.name = true
        }

        if(forDepartment && (!designationPayload.department || designationPayload.department === '')) {
            errors.department = true
        }

        responsibilities.forEach((responsibility, responsibilityIndex)=>{
            if(!responsibility || responsibility === '') {
                errors[`${responsibilityIndex}-responsibility`] = true
            }
        })

        setValidationErrors(errors)

        return errors
    }

    const pushDesignation = async () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            dispatch(createDesignation({
                ...designationPayload, 
                ...{responsibilities: responsibilities}}))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }
  return (
    <div className='w-full'>
        <div className='pb-3 border-b'>
            <p className='text-sm'>Provide the following information to create a new designation</p>
        </div>
        <div className='w-full flex items-start gap-x-8'>
            <div className='w-6/12'>
                <div className='mt-4'>
                    <TextField
                        inputLabel="Designation name" 
                        fieldId="fee-name" 
                        inputType="text" 
                        inputPlaceholder={`eg: Vice Principal`}
                        requiredField={true}
                        preloadValue={designationPayload.name || ''}
                        hasError={validationErrors && validationErrors.name} 
                        returnFieldValue={(value)=>{setDesignationPayload({...designationPayload, ...{name: value}})}}
                    />
                </div>

                <div className='my-2 w-full'>
                    <TextareaField
                        inputLabel="Description" 
                        fieldId="status-note" 
                        inputPlaceholder={`A short description of the designation`}
                        inputType="text" 
                        requiredField={false}
                        preloadValue={designationPayload.description || ''}
                        hasError={false} 
                        maxLength={300}
                        returnFieldValue={(value)=>{setDesignationPayload({...designationPayload, ...{description: value}})}}
                    />
                    {designationPayload?.description?.length === 300 &&<p className='text-red-600 text-xs mt-2'>Please keep the description less than 300 characters</p>}

                </div>

                <div className='mt-4'>
                    <div className="w-full flex justify-between gap-x-4 mt-4 border-secondary border-opacity-50">
                        <div className='w-10/12'>
                            <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Tie to a department</label>
                            <label className="text-xs text-gray-500 font-sofia-pro">This designation will be tied to only a department. This means the designation cannot be assigned to staff of other departments </label>
                        </div>
                        <div className='w-2/12 flex flex-row-reverse'>
                            <Switch
                                checked={forDepartment}
                                onChange={
                                    ()=>{
                                        setForDepartment(!forDepartment)
                                    }
                                }
                                className={`${
                                    forDepartment ? 'bg-accent' : 'bg-gray-400'
                                } relative inline-flex items-center h-5 rounded-full w-10`}
                                >
                                <span className="sr-only">published</span>
                                <span
                                    className={`transform transition ease-in-out duration-200 ${
                                        forDepartment ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                    } inline-block w-3 h-3 transform rounded-full`}
                                />
                            </Switch>
                        </div>
                    </div>
                </div>

                {forDepartment && <div className='mt-4'>
                    <SelectField
                        selectOptions={departmentsSelector?.departments?.departments}
                        inputLabel="Select Department"
                        titleField="name"
                        displayImage={false}
                        imageField=""
                        preSelected=''
                        fieldId="designation-department"
                        hasError={false}
                        // return id of accounts of the selected option
                        returnFieldValue={(value) => {setDesignationPayload({...designationPayload, ...{department: value._id}})}}
                    />
                </div>}
            </div>

            <div className='w-6/12'>
                <div className="w-full flex justify-between gap-x-4 mb-4 border-secondary border-opacity-50">
                    <div className='w-10/12'>
                        <label className="block text-sm font-semibold font-space-grotesk text-gray-700 font-sofia-pro">Can Parent Classes</label>
                        <label className="text-xs text-gray-500 font-sofia-pro">Any Staff with this designation can act as a class parent</label>
                    </div>
                    <div className='w-2/12 flex flex-row-reverse pt-1'>
                        <Switch
                            checked={designationPayload?.canClassParent || false}
                            onChange={() => {setDesignationPayload({...designationPayload, canClassParent: !designationPayload?.canClassParent})}}
                            className={`${
                                designationPayload?.canClassParent ? 'bg-accent' : 'bg-gray-400'
                            } relative inline-flex items-center h-5 rounded-full w-10`}
                            >
                            <span className="sr-only">Can Parent Classes</span>
                            <span
                                className={`transform transition ease-in-out duration-200 ${
                                    designationPayload?.canClassParent ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                } inline-block w-3 h-3 transform rounded-full`}
                            />
                        </Switch>
                    </div>
                </div>

                <div className="w-full flex justify-between gap-x-4 mb-4 border-secondary border-opacity-50">
                    <div className='w-10/12'>
                        <label className="block text-sm text-gray-700 font-space-grotesk font-semibold">Can Parent Houses</label>
                        <label className="text-xs text-gray-500 font-sofia-pro">Any Staff with this designation can act as a house parent</label>
                    </div>
                    <div className='w-2/12 flex flex-row-reverse pt-1'>
                        <Switch
                            checked={designationPayload?.canHouseParent || false}
                            onChange={() => {setDesignationPayload({...designationPayload, canHouseParent: !designationPayload?.canHouseParent})}}
                            className={`${
                                designationPayload?.canHouseParent ? 'bg-accent' : 'bg-gray-400'
                            } relative inline-flex items-center h-5 rounded-full w-10`}
                            >
                            <span className="sr-only">Can Parent Houses</span>
                            <span
                                className={`transform transition ease-in-out duration-200 ${
                                    designationPayload?.canHouseParent ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                } inline-block w-3 h-3 transform rounded-full`}
                            />
                        </Switch>
                    </div>
                </div>

                <p className={`text-sm cursor-text z-10 relative py-1 transition mb-2 block duration-200 text-black`}>
                    <span className="font-space-grotesk font-semibold text-sm">Responsibilities</span> - <span className='text-gray-500 text-sm'>Provide some responsibilities for holders of this designation if necessary. you can click on "add more" button to add more designations. (*You can leave these for later)</span>
                </p>
                
                <div className='w-full relative'>
                    {responsibilities.map((responsibility, responsibilityIndex)=>(<div className='mt-2 flex items-end gap-x-4' key={responsibilityIndex}>
                        <div className='w-full'>
                            <TextField
                                inputLabel="Responsibility" 
                                fieldId={`responsibility-${responsibilityIndex}`}
                                inputPlaceholder={`eg: Supervise students during break time`}
                                inputType="text" 
                                requiredField={false}
                                preloadValue={responsibility || ''}
                                hasError={validationErrors && validationErrors[`${responsibilityIndex}-responsibility`]} 
                                returnFieldValue={(value)=>{updateResponsibility(responsibilityIndex, value)}}
                            />
                        </div>

                        {responsibilityIndex > 0 &&
                        <div className="w-[20px] flex items-center justify-center">
                            <button onClick={()=>{removeResponsibility(responsibilityIndex)}} className='p-1 rounded bg-transparent mb-[10px] hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                <TrashIcon className={`w-5 h-5`} />
                            </button>
                        </div>
                        }
                    </div>))}

                </div>
                <button onClick={()=>{addResponsibility()}} className='p-2 mt-3 rounded bg-transparent font-space-grotesk mb-[10px] bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-xs font-medium flex items-center justify-center text-vcm-purple hover:text-vcm-purple'> <PlusIcon className={`w-4 h-4`} /> Add more</button>
            </div>
        
        </div>

        <div className="mt-8 flex flex-row-reverse gap-x-4">
            <ModalActionButton
                buttonLabel={`Create designation`}
                buttonAction={()=>{pushDesignation()}}
                processing={designationsSelector.creatingDesignation}
            />

            <button
                type="button"
                className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                onClick={closeFunction}
            >
                Cancel
            </button>
            
        </div>
    </div>
  )
}

export default NewStaffDesignation